import React, {
  createContext,
  useContext,
  useRef,
  MutableRefObject,
} from 'react'

interface DialogProviderContextType {
  dialogRef: MutableRefObject<Office.Dialog | null>
  closeDialog: () => void
}

const initialDialogRefContext: DialogProviderContextType = {
  dialogRef: { current: null },
  closeDialog: () => {},
}

const DialogProviderContext = createContext<DialogProviderContextType>(
  initialDialogRefContext
)

export const useDialogContext = () => {
  return useContext(DialogProviderContext)
}

export const DialogProvider = ({ children }: { children: React.ReactNode }) => {
  const dialogRef = useRef<Office.Dialog | null>(null)

  const closeDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.close()
      dialogRef.current = null
    }
  }

  return (
    <DialogProviderContext.Provider value={{ dialogRef, closeDialog }}>
      {children}
    </DialogProviderContext.Provider>
  )
}
